import { gql } from '@apollo/client'

export const EventFragments = {
  info: gql`
    fragment EventInfo on EventNode {
      id
      startsAt
      endsAt
      location
      registrationDeadline
      registrationClosesAt
      registrationOpen

      questions {
        id
        label
        type
        required
        order
      }

      myRegistration {
        id
        status
        note
        updatedAt
        answers {
          id
          value
          question {
            id
          }
        }
      }

      summary {
        attending
        declined
        noResponse
        questions {
          questionId
          label
          type
          yesCount
          total
        }
      }

      registrations {
        id
        status
        note
        updatedAt
        answers {
          id
          value
          question {
            id
          }
        }
        user {
          id
          fullName
          initials
          profilePicture
        }
      }

      nonResponders {
        id
        fullName
      }
    }
  `,
}
